export default __webpack_public_path__ + "static/media/OutDoors.ac6299fa.svg";